import React from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";
import { TextField, InputAdornment } from "@mui/material";

const NumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange(values.value);
      }}
    />
  );
});

NumberFormatCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default function NumericTextField(props) {
  const { value, onChange, ...other } = props;

  return (
    <TextField
      {...other}
      value={value}
      onChange={onChange}
      startIcon={props.startIcon || null}
      InputProps={{
        inputComponent: NumberFormatCustom,
        startAdornment: props.startIcon ? (
          <InputAdornment position="start">{props.startIcon}</InputAdornment>
        ) : null,
        inputProps: {
          ...other,
        },
      }}
    />
  );
}
